import { render, staticRenderFns } from "./GameIframeEmbed.vue?vue&type=template&id=3eda88ce&scoped=true"
import script from "./GameIframeEmbed.vue?vue&type=script&lang=js"
export * from "./GameIframeEmbed.vue?vue&type=script&lang=js"
import style0 from "./GameIframeEmbed.vue?vue&type=style&index=0&id=3eda88ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eda88ce",
  null
  
)

export default component.exports